import React, { useState, useRef } from "react";
import styles from "./Contact.module.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";

import { MdEmail } from "react-icons/md";
import { AiFillPhone } from "react-icons/ai";
import { FaMapMarkerAlt, FaLinkedin } from "react-icons/fa";

const Contact = () => {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState(null);
  const [captchaErrMsg, setCaptchaErrMsg] = useState("");
  const recaptchaRef = useRef();

  const sendMailOnSubmit = (e) => {
    e.preventDefault();
    if (captcha !== null) {
      fetch("https://api.alphaomegazed.com/captcha/check", {
        method: "POST",
        body: JSON.stringify({
          token: captcha,
        }),
      })
        .then(() => {
          fetch("https://api.alphaomegazed.com/trh/contact", {
            method: "POST",
            body: JSON.stringify({
              name: name,
              email: email,
              subject: subject,
              message: message,
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          })
            .then(() => {
              NotificationManager.success(
                "Your email has been sent successfully",
                "Success"
              );
              setName("");
              setEmail("");
              setSubject("");
              setMessage("");
            })
            .catch(() => {
              NotificationManager.error(
                "A problem occurred, please check your information",
                "Error"
              );
            });
          setCaptchaErrMsg(false);
        })
        .catch(() => setCaptchaErrMsg(true));
    } else {
      setCaptchaErrMsg(true);
    }
    setCaptcha(null);
    recaptchaRef.current.reset();
  };

  // const vh2px = value => {
  //     const e = document.documentElement,
  //         g = document.getElementsByTagName('body')[0],
  //         y = window.innerHeight || e.clientHeight || g.clientHeight;

  //     return (y * value) / 100;
  // };

  return (
    <div className={styles.contactContainer}>
      <h2 className={styles.quote}>{t("contact.title")}</h2>
      <div className={styles.emailContainer}>
        <form className={styles.emailForm} onSubmit={sendMailOnSubmit}>
          <p className={styles.constactTitle}>{t("contact.form.title")}</p>
          <label className={styles.emailFormLabel}>
            {t("contact.form.name")}
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label className={styles.emailFormLabel}>
            {t("contact.form.email")}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label
            className={styles.emailFormLabel}
            style={{ marginBottom: "15px" }}
          >
            {t("contact.form.subject")}
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </label>
          <label className={styles.emailFormLabel}>
            {t("contact.form.message")}
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </label>
          <label className={styles.emailFormCaptcha}>
            <ReCAPTCHA
              sitekey="6Lcx4E8iAAAAADswO8L-pEquFdIsJwwrSkdpU_Yf"
              onChange={setCaptcha}
              ref={recaptchaRef}
            />
            {captchaErrMsg && <p style={{ color: "red" }}>Invalid Captcha</p>}
          </label>
          <input
            className={styles.submitBtn}
            type="submit"
            value={t("contact.form.submit")}
          />
        </form>
        <NotificationContainer />
        <div className={styles.contactInfosContainer}>
          <div className={styles.contactInfoContainer}>
            <p className={styles.constactTitle}>{t("contact.info.title")}</p>
            <div className={styles.contactInfo}>
              <a
                href="mailto:info@therecordshub.com"
                target="_blank"
                rel="noreferrer"
              >
                <MdEmail className={styles.contactIcon} size="24" />
              </a>
              <div className={styles.contactInfoContentContainer}>
                <p className={styles.contactInfoTitle}>
                  {t("contact.info.email")}
                </p>
                <p className={styles.contactInfoContent}>
                  info@therecordshub.com
                </p>
              </div>
            </div>
            <div className={styles.contactInfo}>
              <a href="tel:+302113110870" target="_blank" rel="noreferrer">
                <AiFillPhone className={styles.contactIcon} size="24" />
              </a>
              <div className={styles.contactInfoContentContainer}>
                <p className={styles.contactInfoTitle}>
                  {t("contact.info.callUsBtn")}
                </p>
                <p className={styles.contactInfoContent}>+30 2113110870</p>
              </div>
            </div>
            <div className={styles.contactInfo}>
              <a
                href="https://www.google.com/maps/place/Kore+S.A./@37.8830874,23.898348,17z/data=!4m5!3m4!1s0x14a19147a4a62ea1:0xd1b56b96f83ef8a5!8m2!3d37.8830795!4d23.8988037"
                target="_blank"
                rel="noreferrer"
              >
                <FaMapMarkerAlt className={styles.contactIcon} size="24" />
              </a>
              <div className={styles.contactInfoContentContainer}>
                <p className={styles.contactInfoTitle}>
                  {t("contact.location.title")}
                </p>
                <p className={styles.contactInfoContent}>
                  {t("contact.location.address")}
                </p>
              </div>
            </div>
          </div>
          <div className={styles.contactInfoContainer}>
            <p className={styles.constactTitle}>{t("contact.info.media")}</p>
            <div className={styles.contactInfo}>
              {/* <a
                href="https://www.facebook.com/The-Records-Hub-SA-100322322066047?_rdc=1&_rdr"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF className={styles.contactMediaIcon} size="24" />
              </a> */}
              <a
                href="https://www.linkedin.com/company/the-records-hub-s-a/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin className={styles.contactMediaIcon} size="24" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={styles.mapContainer}>
                <p className={styles.mapTitle}>{t('contact.location.title')}</p>
                <p className={styles.mapDescription}>{t('contact.location.address')}</p>
                <iframe
                    title='The Records Hum S.A. location map'
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3149.6800293186698!2d23.9155645!3d37.867776600000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x211a2624b074d54d!2sThe%20Records%20Hub%20S.A.!5e0!3m2!1sen!2sus!4v1663687341468!5m2!1sen!2sus'
                    width='100%'
                    height={vh2px(50)}
                    style={{ border: 0 }}
                    allowFullScreen
                    loading='lazy'
                    referrerPolicy='no-referrer-when-downgrade'
                />
            </div> */}
    </div>
  );
};

export default Contact;
